/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-11-11 09:58:04
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:24:20
 */
export default [
  {
    path: '/open-contract',
    name: 'open-contract',
    meta: {
      name: '开通套餐',
      keepAlive: false,
      showUserName: true
    },
    component: () => import(/* webpackChunkName: "contract" */ '@/views/personal-center/contract-management/open-contract.vue')
  },
  {
    path: '/my-contract',
    name: 'my-contract',
    meta: {
      name: '我的套餐',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "contract" */'@/views/personal-center/contract-management/my-contract.vue')
  },
  {
    path: '/my-account',
    name: 'my-account',
    meta: {
      name: '我的账号',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "personal" */'@/views/personal-center/account-manager/my-account.vue')
  },
  {
    path: '/my-message',
    name: 'my-message',
    meta: {
      name: '我的消息',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "personal" */'@/views/personal-center/personal-message/my-message.vue')
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    meta: {
      name: '订阅套餐',
      parentsName: 'my-contract',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "personal" */'@/views/personal-center/contract-management/subscribe.vue')
  },
]
